import React, { useState } from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';

const UserCard = ({ users, handleEdit, handleToggleStatus }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="md:hidden h-[calc(100vh-220px)] overflow-y-auto pr-1 pb-20">
        <div className="grid gap-4">
        {users.map((user, idx) => (
            <div key={idx} className="border rounded-md shadow p-4 bg-white">
                <div className="flex justify-between items-center">
                    <div>
                        <p className="font-semibold">{u(user.code)}</p>
                        <p className="font-semibold">{u(user.name)}</p>
                        <p className="text-sm text-gray-600">{user.phone}</p>
                        <p className="text-sm text-gray-600">{u(user.email)}</p>
                    </div>
                    <button onClick={() => handleEdit(user)}>
                        <PencilSquareIcon className="w-5 h-5 text-blue-600" />
                    </button>
                </div>

                <div className="mt-2 text-sm">
                <span
                    onClick={() => handleToggleStatus(user)}
                    className={`cursor-pointer ${
                    user.is_active ? 'text-green-600' : 'text-red-500'
                    } font-medium`}
                >
                    {user.is_active ? 'ACTIVE' : 'INACTIVE'}
                </span>
                </div>
            </div>
        ))}
        </div>
    </div>
  );
};

export default UserCard;
